import { useEffect, useState } from "react";
import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import { useToasts } from "react-toast-notifications";

const PageBuilder = ({ products }) => {
  const endPointBaseUrl = global.endpoint;
  const endPointBaseUrlImage = "https://pegaso3cloudapi.pegasogest.it/api/"; //global.endpoint; //'https://pegaso3cloudapi.pegasogest.it/api/'; //global.endpoint;

  const [elements, setElements] = useState([]);
  const [newElement, setNewElement] = useState({
    type: "grid",
    rows: 1,
    cols: 3,
  });
  const [allBanners, setAllBanners] = useState([]);
  const { addToast } = useToasts();

  useEffect(() => {
    getBanners();
  }, []);

  const getBanners = () => {
    const endPoint = endPointBaseUrl + "siteadmin/getAllHomeBanners";
    axios.post(endPoint, { giveBanner: true }).then((response) => {
      if (!response.data.errore) {
        const data = response.data?.data;
        const parsedData = data.map((_banner) => ({
          ..._banner,
          bannerImageScroll: JSON.parse(_banner.bannerImageScroll || []),
        }));
        setAllBanners(parsedData);
      }
    });
  };

  const updateGridElement = (
    gridIndex,
    cellIndex,
    componentType,
    url = "",
    link = "",
    bannerIndex = null,
    content = "",
    width = "auto",
    id = null,
    buttonText = ""
  ) => {
    setElements((prev) => {
      const updatedElements = [...prev];
      const selectedBanner = allBanners[bannerIndex];

      updatedElements[gridIndex].cells[cellIndex] = {
        ...updatedElements[gridIndex].cells[cellIndex],
        type: componentType,
        url,
        link,
        bannerIndex,
        content: content?.length > 0 ? content : buttonText,
        width: updatedElements[gridIndex].cells[cellIndex].width || width,
        id,
        banner: selectedBanner,
        content: buttonText.length > 0 ? buttonText : content,
      };
      return updatedElements;
    });
  };

  const addElement = () => {
    if (newElement.type === "grid") {
      setElements((prev) => [
        ...prev,
        {
          ...newElement,
          cells: Array(newElement.rows * newElement.cols).fill({
            type: "",
            width: "auto",
          }),
        },
      ]);
    } else {
      setElements((prev) => [...prev, newElement]);
    }
  };
  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (e) => reject(e);
    });

  const exportJson = () => {
    const jsonBlob = new Blob([JSON.stringify(elements, null, 2)], {
      type: "application/json",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(jsonBlob);
    link.download = "page_structure.json";
    link.click();
  };

  const sendHomePage = (isNoLogHomepage) => {
    const endPoint = endPointBaseUrl + "siteadmin/saveHomePage";
    console.log({ data: { record: elements, isNoLogHomepage } });
    axios
      .post(endPoint, { data: { record: elements, isNoLogHomepage } })
      .then((response) => {
        if (!response.data?.errore) {
          addToast("Homepage caricata", {
            appearance: "success",
            autoDismiss: true,
            placement: "bottom-left",
          });
        } else {
          addToast("Caricamento non riuscito", {
            appearance: "error",
            autoDismiss: true,
            placement: "bottom-left",
          });
        }
      });
  };
  const impostaHomepage = () => {
    sendHomePage(false);
    exportJson();
  };
  const impostaHomepageNoLog = () => {
    sendHomePage(true);
    exportJson();
  };
  const importJson = (event) => {
    const file = event.target.files[0];
    if (file && file.type === "application/json") {
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const importedData = JSON.parse(reader.result);
          setElements(importedData);
        } catch (error) {
          alert("Errore nel parsing del file JSON");
        }
      };
      reader.readAsText(file);
    } else {
      alert("Per favore seleziona un file JSON valido.");
    }
  };

  const updateGridDimensions = (gridIndex, rows, cols) => {
    if (rows > 0 && cols > 0) {
      setElements((prev) => {
        const updatedElements = [...prev];
        const grid = updatedElements[gridIndex];
        grid.rows = rows;
        grid.cols = cols;
        grid.cells = Array(rows * cols).fill({
          type: "",
          width: "auto",
        });
        return updatedElements;
      });
    } else {
      alert("Le righe e le colonne devono essere numeri positivi.");
    }
  };

  const deleteGrid = (gridIndex) => {
    setElements((prev) => prev.filter((_, index) => index !== gridIndex));
  };

  const handleWidthChange = (gridIndex, cellIndex, width) => {
    const grid = elements[gridIndex];
    const newCells = [...grid.cells];
    const widthPercent = parseInt(width) || 0;

    const totalWidth = newCells.reduce((acc, cell, index) => {
      return (
        acc +
        (cell.width === "auto" || index === cellIndex
          ? 0
          : parseInt(cell.width))
      );
    }, 0);

    if (totalWidth + widthPercent <= 100) {
      newCells[cellIndex] = {
        ...newCells[cellIndex],
        width: widthPercent === 0 ? "auto" : widthPercent,
      };
      setElements((prev) => {
        const updatedElements = [...prev];
        updatedElements[gridIndex] = {
          ...updatedElements[gridIndex],
          cells: newCells,
        };
        return updatedElements;
      });
    } else {
      alert("La somma delle larghezze delle celle non può superare il 100%.");
    }
  };

  const uploadNew = async (file) => {
    const endPoint = `${endPointBaseUrlImage}pegasoCloud/api/upload`;
    const risultato = await axios
      .post(endPoint, { file })
      .then((response) => response.data)
      .catch((error) => error);
    return risultato;
  };

  const submitImage = async (e, index, cellIndex, type, link) => {
    var nameFile = e.target?.files?.[0]?.name;
    fileToBase64(e.target?.files?.[0]).then(async (data) => {
      var url = "";
      const body = {};
      body.file = data.split(",")[1];
      body.name = Date.now() + "." + nameFile.split(".")[1];
      body.isFolder = false;
      body.caricaSuDatabase = false;

      const uploadedFile = await uploadNew(body);
      if (uploadedFile.esito === "OK") url = uploadedFile.linkFile;
      else
        addToast("upload del file non riuscito", {
          appearance: "error",
          autoDismiss: true,
          placement: "bottom-left",
        });
      updateGridElement(index, cellIndex, type, url, link);
    });
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        position: "relative",
        width: "100%",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "20px",
        backgroundColor: "#f5f5f5",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div className="flex justify-between items-center w-full">
        <button
          onClick={impostaHomepage}
          style={{
            padding: "10px 20px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
            zIndex: 10,
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
        >
          Imposta come Homepage
        </button>
        <button
          onClick={impostaHomepageNoLog}
          style={{
            padding: "10px 20px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
            zIndex: 10,
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
        >
          Imposta come Homepage senza login
        </button>

        <button
          onClick={exportJson}
          style={{
            position: "absolute",
            right: "20px",
            padding: "10px 20px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
            zIndex: 10,
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
        >
          Esporta JSON
        </button>
      </div>
      <div style={{ marginTop: "60px" }}>
        <label htmlFor="importJson" style={{ fontWeight: "bold" }}>
          Importa JSON:{" "}
        </label>
        <input
          type="file"
          id="importJson"
          accept=".json"
          onChange={importJson}
          style={{
            padding: "8px",
            border: "1px solid #ddd",
            borderRadius: "8px",
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <label style={{ fontWeight: "bold" }}>Tipo di componente: </label>
        <select
          value={newElement.type}
          onChange={(e) =>
            setNewElement({ ...newElement, type: e.target.value })
          }
          style={{
            padding: "8px",
            border: "1px solid #ddd",
            borderRadius: "8px",
          }}
        >
          <option value="grid">Griglia</option>
        </select>
        {newElement.type === "grid" && (
          <>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <div style={{ display: "none" }}>
                <label>Righe: </label>
                <input
                  type="number"
                  value={newElement.rows}
                  onChange={(e) =>
                    setNewElement({
                      ...newElement,
                      rows: parseInt(e.target.value) || 1,
                    })
                  }
                  min="1"
                  style={{
                    width: "60px",
                    padding: "8px",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                  }}
                />
              </div>
              <div>
                <label>Colonne: </label>
                <input
                  type="number"
                  value={newElement.cols}
                  onChange={(e) =>
                    setNewElement({
                      ...newElement,
                      cols: parseInt(e.target.value) || 1,
                    })
                  }
                  min="1"
                  style={{
                    width: "60px",
                    padding: "8px",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                  }}
                />
              </div>
            </div>
          </>
        )}
        <button
          onClick={addElement}
          style={{
            padding: "10px 20px",
            backgroundColor: "#28a745",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#218838")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#28a745")}
        >
          Aggiungi
        </button>
      </div>

      <div
        style={{
          width: "100%",
          minHeight: "400px",
          border: "1px solid #ddd",
          background: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          overflow: "auto",
        }}
      >
        {elements.map(
          (el, index) =>
            el.type === "grid" && (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ display: "none" }}>
                      <label>Righe: </label>
                      <input
                        type="number"
                        value={el.rows}
                        onChange={(e) =>
                          updateGridDimensions(
                            index,
                            parseInt(e.target.value) || 1,
                            el.cols
                          )
                        }
                        min="1"
                        style={{
                          width: "60px",
                          padding: "8px",
                          borderRadius: "8px",
                          border: "1px solid #ddd",
                        }}
                      />
                    </div>
                    <div>
                      <label>Colonne: </label>
                      <input
                        type="number"
                        value={el.cols}
                        onChange={(e) =>
                          updateGridDimensions(
                            index,
                            el.rows,
                            parseInt(e.target.value) || 1
                          )
                        }
                        min="1"
                        style={{
                          width: "60px",
                          padding: "8px",
                          borderRadius: "8px",
                          border: "1px solid #ddd",
                        }}
                      />
                    </div>
                  </div>
                  <button
                    onClick={() => deleteGrid(index)}
                    style={{
                      padding: "6px 12px",
                      backgroundColor: "#dc3545",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      cursor: "pointer",
                    }}
                  >
                    Elimina Griglia
                  </button>
                </div>

                <div
                  style={{
                    display: "flex",
                    gridTemplateRows: `repeat(${el.rows}, 1fr)`,
                    gridTemplateColumns: `repeat(${el.cols}, 1fr)`,
                    gap: "10px",
                    marginTop: "20px",
                  }}
                >
                  {el.cells.map((cell, cellIndex) => (
                    <div
                      key={cellIndex}
                      style={{
                        border: "1px solid #ddd",
                        padding: "20px",
                        minHeight: "100px",
                        overflow: "auto",
                        borderRadius: "8px",
                        backgroundColor: "#f9f9f9",
                        width:
                          cell.width === "auto" ? "auto" : `${cell.width}%`,
                        boxSizing: "border-box",
                      }}
                    >
                      <select
                        onChange={(e) =>
                          updateGridElement(index, cellIndex, e.target.value)
                        }
                        value={cell?.type || ""}
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          width: "100%",
                          marginBottom: "10px",
                        }}
                      >
                        <option value="">Seleziona componente</option>
                        <option value="button">Pulsante</option>
                        <option value="image">Immagine</option>
                        <option value="text">Testo</option>
                        <option value="carousel">Carosello</option>
                        <option value="video">Video</option>
                        <option value="articolo">Articolo</option>
                      </select>

                      {cell.type === "image" && (
                        <>
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <input
                              type="file"
                              className="hidden"
                              id="image-upload"
                              name="img"
                              accept="image/*"
                              onChange={(e) =>
                                submitImage(
                                  e,
                                  index,
                                  cellIndex,
                                  cell.type,
                                  cell.link
                                )
                              }
                            />
                            <input
                              type="text"
                              placeholder="URL dell'immagine"
                              value={cell.url || ""}
                              onChange={(e) =>
                                updateGridElement(
                                  index,
                                  cellIndex,
                                  cell.type,
                                  e.target.value,
                                  cell.link
                                )
                              }
                              style={{
                                padding: "8px",
                                borderRadius: "8px",
                                border: "1px solid #ddd",
                                width: "100%",
                                marginBottom: "10px",
                              }}
                            />
                          </div>
                          <input
                            type="text"
                            placeholder="Link di redirect"
                            value={cell.link || ""}
                            onChange={(e) =>
                              updateGridElement(
                                index,
                                cellIndex,
                                cell.type,
                                cell.url,
                                e.target.value
                              )
                            }
                            style={{
                              padding: "8px",
                              borderRadius: "8px",
                              border: "1px solid #ddd",
                              width: "100%",
                              marginBottom: "10px",
                            }}
                          />
                        </>
                      )}

                      {cell.type === "carousel" && (
                        <select
                          value={cell.bannerIndex || ""}
                          onChange={(e) =>
                            updateGridElement(
                              index,
                              cellIndex,
                              cell.type,
                              cell.url,
                              cell.link,
                              e.target.value
                            )
                          }
                          style={{
                            padding: "8px",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            width: "100%",
                            marginBottom: "10px",
                          }}
                        >
                          <option value="">Seleziona un banner</option>
                          {allBanners.map((banner, bannerIndex) => (
                            <option key={bannerIndex} value={bannerIndex}>
                              {banner.bannerName}
                            </option>
                          ))}
                        </select>
                      )}

                      {cell.type === "articolo" && (
                        <select
                          value={cell.id || ""}
                          searchable="Search here.."
                          autoComplete="on"
                          onChange={(e) =>
                            updateGridElement(
                              index,
                              cellIndex,
                              cell.type,
                              cell.url,
                              cell.link,
                              cell.bannerIndex,
                              null,
                              cell.width,
                              e.target.value
                            )
                          }
                          style={{
                            padding: "8px",
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            width: "100%",
                            marginBottom: "10px",
                          }}
                        >
                          <option value="">Seleziona un articolo</option>
                          {products
                            .sort((a, b) => {
                              if (a.sku < b.sku) return -1;
                              if (a.sku > b.sku) return 1;
                              return 0;
                            })
                            .map((product, productIndex) => (
                              <option key={product.id} value={product.id}>
                                {product.sku} - {product.name}
                              </option>
                            ))}
                        </select>
                      )}

                      {cell.type === "button" && (
                        <>
                          <input
                            type="text"
                            placeholder="Testo del pulsante" // Campo per il testo del pulsante
                            value={cell.content || ""}
                            onChange={(e) =>
                              updateGridElement(
                                index,
                                cellIndex,
                                cell.type,
                                cell.url,
                                cell.link,
                                undefined,
                                undefined,
                                undefined,
                                undefined,
                                e.target.value // Aggiorna il testo del pulsante
                              )
                            }
                            style={{
                              padding: "8px",
                              borderRadius: "8px",
                              border: "1px solid #ddd",
                              width: "100%",
                              marginBottom: "10px",
                            }}
                          />
                          <input
                            type="text"
                            placeholder="Link del pulsante"
                            value={cell.link || ""}
                            onChange={(e) =>
                              updateGridElement(
                                index,
                                cellIndex,
                                cell.type,
                                cell.url,
                                e.target.value,
                                undefined,
                                undefined,
                                undefined,
                                undefined,
                                cell.content // Aggiorna il testo del pulsante
                              )
                            }
                            style={{
                              padding: "8px",
                              borderRadius: "8px",
                              border: "1px solid #ddd",
                              width: "100%",
                              marginBottom: "10px",
                            }}
                          />
                        </>
                      )}

                      {cell.type === "video" && (
                        <input
                          type="text"
                          placeholder="id video YouTube"
                          value={cell.url || ""}
                          onChange={(e) =>
                            updateGridElement(
                              index,
                              cellIndex,
                              cell.type,
                              e.target.value,
                              cell.link
                            )
                          }
                          style={{
                            padding: "8px",
                            borderRadius: "8px",
                            border: "1px solid #ddd",
                            width: "100%",
                            marginBottom: "10px",
                          }}
                        />
                      )}

                      {cell.type === "text" && (
                        <textarea
                          placeholder="Testo da visualizzare"
                          value={cell.content || ""}
                          onChange={(e) =>
                            updateGridElement(
                              index,
                              cellIndex,
                              cell.type,
                              cell.url,
                              cell.link,
                              null,
                              e.target.value
                            )
                          }
                          style={{
                            padding: "8px",
                            borderRadius: "8px",
                            border: "1px solid #ddd",
                            width: "100%",
                            marginBottom: "10px",
                          }}
                        />
                      )}

                      <input
                        type="number"
                        value={cell.width === "auto" ? "" : cell.width}
                        onChange={(e) =>
                          handleWidthChange(index, cellIndex, e.target.value)
                        }
                        min="0"
                        max="100"
                        step="1"
                        placeholder="Larghezza %"
                        style={{
                          padding: "8px",
                          borderRadius: "8px",
                          border: "1px solid #ddd",
                        }}
                      />
                      <p>{((1524 * cell.width) / 100).toFixed(0)} px</p>
                    </div>
                  ))}
                </div>
              </div>
            )
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    products: state.productData.products,
    userData: state.userData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(PageBuilder);
